import { Action } from '@ngrx/store';

export enum AdtQuantityActionTypes {
    LOAD_QUANTITY_SELECTED = '[ADT Quantity] Load Quantity Selected',
    LOAD_INITIAL_QUANTITY = '[ADT Quantity] Load Initial Quantity',
    RESET = '[ADT Quantity] Reset Quantity',
}

/**
 * Load quantity selected
 */
export class AdtLoadQuantitySelectedAction implements Action {
    readonly type = AdtQuantityActionTypes.LOAD_QUANTITY_SELECTED;

    constructor(public payload: {[formId: string]: number}) { }
}

/**
 * Load initial quantity
 */
export class AdtLoadInitialQuanatityAction implements Action {
    readonly type = AdtQuantityActionTypes.LOAD_INITIAL_QUANTITY;

    constructor(public payload: number) { }
}

/**
 * Reset quantity store
 */
export class AdtResetQuantityAction implements Action {
    readonly type = AdtQuantityActionTypes.RESET;

    constructor(payload?: any) { }
}

export type AdtQuantityActions =
    | AdtLoadQuantitySelectedAction
    | AdtLoadInitialQuanatityAction
    | AdtResetQuantityAction;
